import { IntlShape } from 'react-intl';

export const getQuantityString = (quantity: number) => {
    if (quantity >= 1000) {
        return `${quantity / 1000}k`;
    }
    return quantity.toString();
};

export const getQuantityStringByIntl = (quantity: number, intl: IntlShape) => {
    return intl.formatNumber(quantity, {
        notation: 'compact',
        maximumSignificantDigits: 3,
    });
};

export const convertDurationToDisplay = (durationMS: number, intl: IntlShape) => {
    const durationH = durationMS / (1000 * 60 * 60);

    if (durationH >= 1) {
        return intl.formatMessage(
            {
                id: 'common.duration.short.hours',
            },
            {
                duration: durationH.toFixed(1),
            },
        );
    }

    const durationM = durationMS / (1000 * 60);
    if (durationM >= 1) {
        return intl.formatMessage(
            {
                id: 'common.duration.short.minutes',
            },
            {
                duration: durationM.toFixed(1),
            },
        );
    }

    const durationS = durationMS / 1000;
    return intl.formatMessage(
        {
            id: 'common.duration.short.seconds',
        },
        {
            duration: durationS.toFixed(1),
        },
    );
};
